import { InfoOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, Form, Input, message, Modal, Row, Select, Spin } from 'antd';
import React, { useState } from 'react';
import ZTable, { IFilterItem, ITableRef, IColumnType } from '@/components/ZTable';
import { useTranslation } from 'react-i18next';
import { ModalWidth, ROW_GUTTER, VALIDATE_REQUIRED } from '@/config';
import { EmployeeType } from '@/constants';
import CreateBtn from '@/components/app/CreateBtn';
import MainContent from '@/layouts/MainContent';
import { Helmet } from 'react-helmet';
import { defaultApiErrorHandle } from '@/helpers/errorHandler';
import { CompanyUserDto, RoleDetailModel } from '@/__generated';
import { apiSdk } from '@/httpClient';
const PAGE_TITLE = 'companyRolesPage_Title';

const columns: IColumnType<CompanyUserDto>[] = [
  {
    title: 'companyRolesPage_RoleName',
    dataIndex: 'name',
    ellipsis: true,
  },
  {
    title: 'companyRolesPage_NormalizedName',
    dataIndex: 'normalizedName',
    ellipsis: true,
  },
];

const filters: Array<IFilterItem> = [{ type: 'TEXT', name: 'name', label: 'companyRolesPage_RoleName' }];

const CompanyRolePage = () => {
  const { t } = useTranslation();
  const zTb = React.useRef<ITableRef>();
  const [form] = Form.useForm();
  const [roleId, setRoleId] = useState<string>();
  const [roleDetail, setRoleDetail] = useState<RoleDetailModel>();

  const [loading, setLoading] = useState(false);
  const [permissions, setPermissions] = React.useState<Array<{ value: any; label: any }>>([]);

  React.useEffect(() => {
    apiSdk.RoleService.getCompanyPermissions().then(res => {
      setPermissions(res?.map(x => ({ value: x, label: x })) || []);
    });
  }, []);

  const viewDetail = (id: string) => {
    setLoading(true);
    setRoleId(id);
    apiSdk.RoleService.getRoleDetails({ id: id })
      .then(res => {
        if (res) {
          setRoleDetail(res);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <MainContent isLoading={loading} title={t(PAGE_TITLE)}>
      <Helmet title={t(PAGE_TITLE)} />
      <div className="ant-layout-content-body">
        <ZTable
          columns={columns}
          primaryKey="id"
          tableRef={zTb}
          defaultVariables={{
            employeeType: EmployeeType.Employee,
          }}
          url="/user-accounts/roles/get-company-roles"
          bordered
          order_by="name"
          order_by_asc={true}
          allowEdit={false}
          extraActions={[
            {
              render: record => {
                return (
                  <Button
                    loading={loading}
                    style={{ borderRadius: 0 }}
                    type="primary"
                    size="small"
                    icon={<InfoOutlined />}
                    onClick={() => {
                      viewDetail(record.id || '');
                    }}
                  />
                );
              },
            },
          ]}
          allowDelete={false}
          filters={filters}
          searchBtnAlignLeft
        />
        <Modal
          open={!!roleId}
          maskClosable={true}
          width={ModalWidth.small}
          className="nta-custom-form"
          title={'Role detail'}
          forceRender={true}
          style={{ top: 10 }}
          cancelText={t('Close')}
          okButtonProps={{ style: { display: 'none' } }}
          onCancel={() => {
            form.resetFields();
            setRoleId(undefined);
            setRoleDetail(undefined);
          }}
        >
          <Spin spinning={loading}>
            <Row gutter={ROW_GUTTER}>
              <Col md={24}>
                <Form.Item label={t('companyRolesPage_RoleName')}>
                  <Input value={roleDetail?.name} disabled={true} className="input-value-color" />
                </Form.Item>
                <b>{t('companyRolesPage_Permissions')}</b>
                {roleDetail ? (
                  <Form.Item>
                    <Checkbox.Group value={roleDetail?.permissions || []}>
                      <Row gutter={ROW_GUTTER}>
                        {permissions.map(p => {
                          return (
                            <Col md={12} key={p.value}>
                              <Checkbox value={p.value}>{p.label}</Checkbox>
                            </Col>
                          );
                        })}
                      </Row>
                    </Checkbox.Group>
                  </Form.Item>
                ) : null}
              </Col>
            </Row>
          </Spin>
        </Modal>
      </div>
    </MainContent>
  );
};
export default CompanyRolePage;
